import axios from "axios";
import { toast } from "react-toastify";
import { ClientApi } from ".";

export const fetchClients = ({ params }) => {
  return axios
    .get(`${ClientApi}`, { params: { ...params } })
    .then((res) => {
      return res?.data ?? null;
    })
    .catch(() => {
      return [];
    });
};
